module.exports = __webpack_public_path__ + "static/big-class-diagram-without-beans1.a9786fb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/git-github-presentation/big-class-diagram-without-beans1.png
// module id = 1059
// module chunks = 32308089046778